import "../styles/error.css";
import React from "react";


const Error = () => {
 

  return (
    <div className="wrapper">
      Error
    </div>
  );
};

export default Error;
